// CenterLoader.tsx
import React from "react";

const CenterLoader: React.FC = () => {
  return (
    <div className='fixed inset-0 flex items-center justify-center bg-white bg-opacity-70 z-50'>
      <div className='w-12 h-12 border-4 border-orange-400 border-t-transparent rounded-full animate-spin'></div>
    </div>
  );
};

export default CenterLoader;
